// Values used across the legal pages. Confirmed with Andy 2026-07-08.
export const SITE = {
  LEGAL_NAME: 'Plateau Nerd',
  CONTACT_EMAIL: 'motab909@gmail.com',
  DOMAIN: 'eliza.motab.com',
  EFFECTIVE_DATE: 'July 8, 2026'
};
